import { constants } from '@tradetrust-tt/token-registry-v5';

const supportInterfaceIds = constants.contractInterfaceId;

export { supportInterfaceIds };
